import { create } from 'zustand'

import { DEFAULT_BUY_TOKEN, DEFAULT_SELL_TOKEN } from '@src/configs/defaults'
import { StepNames } from '@src/enums'
import { ITransactionStatus } from '@src/types/transactionStatus'

export const DEFAULT_STEPS: Record<StepNames, { label: string }> = {
    UNSTARTED: { label: 'Swap has not been started' },
    SWITCH_NETWORKS: { label: 'Switching network' },
    APPROVE_TOKENS_PENDING: { label: 'Approving tokens' },
    APPROVE_TOKENS: { label: 'Approve in Wallet' },
    DEPOSIT_WETH_PENDING: { label: 'Wrapping gas' },
    DEPOSIT_WETH: { label: 'Wrap gas' },
    UNWRAP_WETH_PENDING: { label: 'Unwrapping gas' },
    UNWRAP_WETH: { label: 'Unwrap gas' },
    CONFIRM_SWAP: { label: 'Confirm Swap' },
    CONFIRM_SWAP_PENDING: { label: 'Confirming swap' },
    MATCHING: { label: 'Matching order' },
    MATCH_CREATED: { label: 'Match created' },
    MATCH_EXECUTED: { label: 'Match executed' },
    MATCH_TIMED_OUT: { label: 'Match timed out' },
}

const defaultTransactionStatus: ITransactionStatus = {
    sellData: {
        token: DEFAULT_SELL_TOKEN,
        chainId: DEFAULT_SELL_TOKEN.chainId,
        value: BigInt(0),
    },
    buyData: {
        token: DEFAULT_BUY_TOKEN,
        chainId: DEFAULT_BUY_TOKEN.chainId,
        value: BigInt(0),
    },
    exchangeId: '',
    orderId: '',
    currentStep: StepNames.UNSTARTED,
    steps: DEFAULT_STEPS,
    visible: true,
}

type HistoryStore = {
    history: Record<string, ITransactionStatus>
    updateHistory: (exchangeId: string | null, data: Partial<ITransactionStatus>) => void
    removeHistory: (exchangeId: string) => void
    getOrder: (exchangeId: string) => ITransactionStatus
}

export const useHistoryStore = create<HistoryStore>((set, get) => ({
    history: {},

    updateHistory: (exchangeId, data) => {
        set(state => {
            if (exchangeId === null) {
                exchangeId = Object.keys(get().history)[0]
            }
            const existingHistory = state.history[exchangeId] || defaultTransactionStatus
            return {
                history: {
                    ...state.history,
                    [exchangeId]: { ...existingHistory, ...data },
                },
            }
        })
    },

    removeHistory: exchangeId => {
        set(state => {
            const { [exchangeId]: _, ...remainingHistory } = state.history
            return { history: remainingHistory }
        })
    },

    getOrder: exchangeId => {
        const state = get()
        return state.history[exchangeId] || defaultTransactionStatus
    },
}))
